import { useEffect, useState, useContext } from "react";
import { ShopContext } from "../Context/ShopContext";
import images from "../../assets/images/assets";
import { useLocation } from "react-router-dom";

const SearchBar = () => {
  // From  Context File
  const { search, setSearch, showSearch, setShowSearch } =
    useContext(ShopContext);
  // --------------------------------

  const [visible, setVisible] = useState(false);

  const location = useLocation();
  // console.log(location);

  useEffect(() => {
    if (location.pathname.includes("collections")) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [location]);

  return showSearch && visible ? (
    <div className="border-t border-t-prime-red bg-zinc-50 text-center">
      <div className="inline-flex items-center justify-center border border-gray-400 px-5 py-2 my-5 mx-3 rounded-full w-3/4 sm:w-1/2">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="flex-1 outline-none bg-inherit text-sm"
          type="text"
          placeholder="Search"
        />
        <img src={images.search} alt="search icon" className="w-4" />
      </div>

      <img
        onClick={() => setShowSearch(false)}
        src={images.cross_icon}
        alt="icon"
        className="inline w-3 cursor-pointer"
      />
    </div>
  ) : null;
};

export default SearchBar;
